




















































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import Top10Table from '@/components/stats/top10-table.vue';
import {
    IDashboardStatsModel,
    IStatPeriodItemModel,
    IModelWithLoading
} from '@/entities';
import * as types from '@/store/types';
import { mapGetters } from 'vuex';

@Component({
    components: {
        'top10-table': Top10Table
    },
    computed: mapGetters({
        model: types.APIDATA_GET_DASHBOARD,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS
    })
})
export default class Top10Agents extends Vue {
    public model: IModelWithLoading<IDashboardStatsModel>;

    get stats() {
        return this.model.model;
    }

    public created() {
        this.$store.dispatch(types.APIDATA_DASHBOARD_ENTER);
    }

    private getItemClass(item: IStatPeriodItemModel) {
        if (item.progress > 0) {
            return 'success';
        } else {
            return 'fail';
        }
    }

    private getItemStyles(item: IStatPeriodItemModel) {
        if (item.progress > 0) {
            return {color: 'green'};
        } else {
            return {color: '#F01A22'};
        }
    }
}
